import React from 'react';

const Notifications: React.FC = () => {
    return (
        <div>
            <h1>Notifications</h1>
            <p>This is the Notifications page.</p>
        </div>
    );
};

export default Notifications;